import { StreakDay } from "..";
import { getNextCollectionDay, useWeekStreak } from "../../hooks";
import { useDailyLoginStreak } from "../..";
import { useAppDispatch, useAppSelector } from "hooks";
import { ClaimButton, Container, Progress } from "./styles";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { collectDailyBonus, selectDailyLoginStreakState } from "redux/slices";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import useRewardsById from "hooks/useRewardsById";
import { getCount, getDisplay, getTimeLeft } from "utils/time";

interface DailyProgressProps {}

export const DailyProgress: React.FC<DailyProgressProps> = () => {
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const { tracker } = useDailyLoginStreak();
	const { streakDays } = tracker;
	const { isClaiming } = useAppSelector(selectDailyLoginStreakState);
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { today } = useWeekStreak(streakDays);
	const { showErrorDialog } = useDialogModalRedux();
	const alreadyCollected = today && "collectedDate" in today;

	//gets rewardId of the current day to differentiate loyalty points when claiming
	const rewards = useRewardsById(today?.rewardId);

	const analyticsReport = () => {
		const timeRemaining = getCount(nowTime, today.endOfDay);
		const timeToDisplay: string = getDisplay(timeRemaining);
		const nextCollectionDay: number | undefined =
			getNextCollectionDay(tracker)?.dayIndex;
		const numberDayGiftClaimed: number = nextCollectionDay
			? nextCollectionDay + 1
			: 1;
		reportEvent("daily_gift_streak_claim", {
			number_day_gift_claimed: numberDayGiftClaimed,
			time_remaining: timeToDisplay,
			source: "daily_gift_streak"
		});
		const timeLeft = getTimeLeft(nowTime, today.endOfDay, "seconds");
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "daily_gift_streak_claim",
			event_type: "web_daily_login_streak",
			action: "daily_gift_streak_claim",
			source: "daily_gift_streak",
			node_type: numberDayGiftClaimed?.toString(),
			time_left: timeLeft
		});
	};

	return (
		<Container>
			<Progress>
				{streakDays.map((streak, key) => (
					<StreakDay
						key={key}
						streakDay={streak}
						lastItem={key + 1 === streakDays.length}
					/>
				))}
			</Progress>
			<ClaimButton
				disabled={isClaiming || !!alreadyCollected}
				onClick={() => {
					dispatch(
						collectDailyBonus({ showErrorDialog, rewardId: rewards[0]?.id })
					);
					analyticsReport();
				}}
			>
				{isClaiming ? "Claiming..." : alreadyCollected ? "Collected" : "Claim"}
			</ClaimButton>
		</Container>
	);
};
